<template>
  <div class="footer-wrap" v-show="this.$route.name != 'Index'">
    <div class="footer-cont clear">
      <div class="footer-logo fl">
        <!-- <i class="iconfont f-icon">&#xe604;</i> -->
        <img src="../../../static/img/logo-bottom.png" alt="">
      </div>
      <ul class=" fl clear">
      	<!--更多弹出样式-->
        <li class="fl">
        	<Tooltip placement="top" class="contact-us">
			        <Button class='tips' @mouseenter="enter()" @mouseleave="leave()">更多
			        	<i class="iconfont more-btn" v-if="status">&#xe650;</i>
			        	<i class="iconfont more-btn" v-else>&#xe651;</i>
			        </Button>
			        <div slot="content">
			        		<ul class='more-list'>
                    <!-- 更多弹出框列表通过渲染tipsArr获取 -->
                    <li v-for='item in tipsArr'>
			        				<i class="iconfont" v-html='item.icon' :class="{'special' : item.name == '关于我们'}"></i>
			        				<a :href="baceUrl + item.url" target="_blank">{{item.name}}</a>
			        			</li>
			        		</ul>
			        </div>
			    </Tooltip>
        </li>
        <div class="line fl"></div>
        <li class="fl"><a href="http://breadoffer.com/aboutus/qa.html" target="_blank">常见问题</a></li>
        <div class="line fl"></div>
        <!--联系我们-->
        <li class="fl">
        	<Tooltip placement="top" class="contact-us">
			        <Button class='tips'>联系我们</Button>
			        <div slot="content">
			        		<p class="phone-icon"><i class="iconfont">&#xe6d9;</i></p>
			            <p class="tel">15652730502</p>
			            <p class="work-time">工作日：10:00-19:00</p>
			            <p class="kefu"><span>客服电话</span></p>
			        </div>
			    </Tooltip>
        </li>
        <div class="line fl"></div>
        <!--关注微博-->
        <li class="fl weibo">
        	<a href="http://www.weibo.com/breadoffer?refer_flag=1005055013_" target="_blank"><i class="iconfont">&#xe6c7;</i></a>
        </li>
        <!--微信弹出框-->
        <li class="fr weichat" >
        		<Tooltip placement="top" class="contact-us">
			        <Button class='tips'><i class="iconfont">&#xe6c6;</i></Button>
			        <div slot="content">
			        		<div class="img-box">
			        			<img src="../../../static/img/erweima.png" alt="" />
			        		</div>
			        </div>
			    </Tooltip>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {Tooltip} from 'iview'; // 引入气泡提示组件

export default{
	data(){
		return{
			status:true, // 用来控制更多右侧展开、收起样式
      baceUrl:'http://breadoffer.com/', // 更多bace链接
      tipsArr:[ //渲染更多弹出框数据
        {icon:'&#xe653;',url:'',name:'返回面包首页'},
        {icon:'&#xe64d;',url:'course/list.html',name:'课程频道'},
        {icon:'&#xe6df;',url:'teacher/list.html',name:'导师频道'},
        {icon:'&#xe6db;',url:'gain.html',name:'学员成果'},
        {icon:'&#xe6de;',url:'job/recruit.html',name:'导师招募'},
        {icon:'&#xe6dd;',url:'aboutus/join.html',name:'加入我们'},
        {icon:'&#xe6da;',url:'aboutus/index.html',name:'关于我们'},
        {icon:'&#xe6dc;',url:'aboutus/qa.html',name:'常见问题'},
      ]
		}
	},
  components:{
  	'Tooltip':Tooltip,
  },
  methods:{
  	enter(){
  		this.status = false;
  	},
  	leave(){
  		this.status = true;
  	}
  }
}
</script>

<style scoped lang="scss">
@import  "../../sass/mixin";


.footer-wrap{
  width:100%;
  height:40px;
  background-color: #2b2b2b;
  .footer-cont{
    width:1170px;
    height:40px;
    overflow: hidden;
    margin:$mc;
    padding-top:3px;

    .footer-logo{
      width:100px;
      height:40px;
      line-height: 10px;
      margin-top:-13px;
      left:0;
      img{
        width:80px;
        height:60px;
        display: block;
        // width:100%;
      }
      .f-icon{
        font-size:60px;
        color:#cccccc;
      }
    }
    ul{
      color:#747474;
      font-size:12px;
      line-height: 40px;
      li{
        width:59px;
        .more-btn{
          font-size:10px;
          margin-left:12px;
        }
        a{
        	color:#747474;
        }
      }
      .line{
        width:1px;
        height:15px;
        background-color: #555555;
        margin:12px 33px 0 28px;
      }
    }
  }
}
/*更多弹框样式*/
.more-list{
	width:140px;
	padding:10px 0 30px 10px;
	li{
		color:#ccc;
		height:30px;
		line-height:30px;
		@include transition(all 0.3s);
		a{
			color:#ccc !important;
		}
		i{
			margin-right:15px;
		}
    .special{
      margin-right:11px;
    }
		&:hover{
			color:#f3d872;
			@include transition(all 0.3s);
			a{
				color:#f3d872 !important;
				@include transition(all 0.3s);
			}
		}
	}

}
/*联系我们弹出样式*/
.contact-us{
	.tips{
		color:#747474;
		background-color: #2b2b2b;
	}
	.phone-icon{
		margin:10px 0;
	}
	div{
		color:#ACACAC;
		.tel{
			font-size:20px;
			/*font-weight:bold;*/
		}
		.kefu{
			margin-bottom:15px;
			span{
				display: inline-block;
				width:70px;
		    height: 20px;
		    line-height: 21px;
		    font-size: 12px;
		    color: #2a2a2a;
		    background: #FCDA78;
		    text-align: center;
		    border-radius: 3px;
		    margin-top: 12px;
			}
		}
	}
}
/*微博、微信二维码弹出样式*/
.weibo{
  text-align: center;
  line-height: 38px;
  margin-left:-8px;
	i{
		font-size:22px;
	}
}
.weichat{
  @extend .weibo;

  .img-box{
  	padding:10px;
  	img{
  		width:100%;
  	}
  }
}

</style>



// WEBPACK FOOTER //
// footer.vue?02942b94